import { updateObject } from '../../helpers/utility.helper';
import { initialState } from '../state/sensorDataChart.state';
import ISensorDataChartState from '../models/ISensorDataChartState';
import iaqSensorDataChartType from '../types/iaqSensorDataChart.type';

const getIAQSensorDataChartStart = (oldState: ISensorDataChartState, action: any) => {
    return updateObject(oldState, {
        sensorDataChartList: updateObject(oldState.sensorDataChartList, {
            error: null, loading: true, success: false
        })
    });
};

const getIAQSensorDataChartSuccess = (oldState: ISensorDataChartState, action: any) => {
    return updateObject(oldState, {
        sensorDataChartList: updateObject(oldState.sensorDataChartList, {
            datas: action.payload,
            error: null,
            loading: false,
            success: true,
        })
    });
};

const getIAQSensorDataChartError = (oldState: ISensorDataChartState, action: any) => {
    return updateObject(oldState, {
        sensorDataChartList: updateObject(oldState.sensorDataChartList, {
            error: action.payload,
            success: false,
            loading: false
        })
    });
};

const resetGetIAQSensorDataChartState = (oldState: ISensorDataChartState, action: any) => {
    return updateObject(oldState, {
        sensorDataChartList: updateObject(oldState.sensorDataChartList, {
            datas: action.payload,
            error: null,
            success: false,
            loading: false
        })
    });
};

const resetGetIAQSensorDataChartSuccessState = (oldState: ISensorDataChartState, action: any) => {
    return updateObject(oldState, {
        sensorDataChartList: updateObject(oldState.sensorDataChartList, {
            //datas: action.payload,
            error: null,
            success: false,
            loading: false
        })
    });
};

const iaqSensorDataChartReducer = (oldState: ISensorDataChartState = initialState, action: any) => {
    switch (action.type) {
        case iaqSensorDataChartType.GET_IAQ_SENSOR_DATA_CHART_START: return getIAQSensorDataChartStart(oldState, action);
        case iaqSensorDataChartType.GET_IAQ_SENSOR_DATA_CHART_SUCCESS: return getIAQSensorDataChartSuccess(oldState, action);
        case iaqSensorDataChartType.GET_IAQ_SENSOR_DATA_CHART_ERROR: return getIAQSensorDataChartError(oldState, action);
        case iaqSensorDataChartType.RESET_IAQ_SENSOR_DATA_CHART: return resetGetIAQSensorDataChartState(oldState, action);
        case iaqSensorDataChartType.RESET_IAQ_SENSOR_DATA_CHART_SUCCESS: return resetGetIAQSensorDataChartSuccessState(oldState, action);
        default: return oldState;
    }
};
export default iaqSensorDataChartReducer;